// Local translations
export const T = {
  en_GB: {
    done: "Done",
    close: "Close",
    submitFailed: "Could not save your answers. Please try again.",
  },
  nb_NO: {
    done: "Ferdig",
    close: "Lukk",
    submitFailed: "Kunne ikke lagre svarene dine. Prøv igjen.",
  },
} as const;
